import cn from "classnames";

export function RawHTML(props: { className?: string; children: any }) {
    const { className, children } = props;

    return <div className={cn("raw-html", className)} dangerouslySetInnerHTML={{ __html: children }} />;
}
